export type Character = {
    width: number;
    height?: number,
    x?: number,
    y?: number,
    marginRight?: number,
    marginLeft?: number,
    translateY?: number
}

export const characters: Record<string, Character | {
    sameAs: string
}>= {
    " ": {
      "width": 3
    },
    "0": {
      "width": 7,
      "height": 10,
      "x": 0,
      "y": 265,
      "marginRight": 1
    },
    "1": {
      "width": 7,
      "height": 10,
      "x": 7,
      "y": 265,
      "marginLeft": -1
    },
    "2": {
      "width": 7,
      "height": 10,
      "x": 14,
      "y": 265
    },
    "3": {
      "width": 7,
      "height": 10,
      "x": 21,
      "y": 265
    },
    "4": {
      "width": 7,
      "height": 10,
      "x": 28,
      "y": 265
    },
    "5": {
      "width": 7,
      "height": 10,
      "x": 35,
      "y": 265
    },
    "6": {
      "width": 7,
      "height": 10,
      "x": 42,
      "y": 265,
      "marginRight": 1
    },
    "7": {
      "width": 7,
      "height": 10,
      "x": 49,
      "y": 265,
      "marginRight": -1
    },
    "8": {
      "width": 7,
      "height": 10,
      "x": 56,
      "y": 265
    },
    "9": {
      "width": 7,
      "height": 10,
      "x": 63,
      "y": 265
    },
    "&": {
      "width": 10,
      "height": 10,
      "x": 70,
      "y": 265
    },
    "*": {
      "width": 6,
      "height": 5,
      "x": 80,
      "y": 265,
      "translateY": -5
    },
    "@": {
      "width": 10,
      "height": 10,
      "x": 86,
      "y": 265
    },
    "[": {
      "width": 4,
      "height": 13,
      "x": 96,
      "y": 262,
      "translateY": 3,
      "marginLeft": 1
    },
    "]": {
      "width": 4,
      "height": 13,
      "x": 100,
      "y": 262,
      "translateY": 3
    },
    ":": {
      "width": 2,
      "height": 7,
      "x": 104,
      "y": 268
    },
    ",": {
      "width": 4,
      "height": 5,
      "x": 106,
      "y": 272,
      "translateY": 2,
      "marginRight": -1
    },
    "-": {
      "width": 5,
      "height": 2,
      "x": 110,
      "y": 269,
      "translateY": -3,
      "marginRight": -1
    },
    "–": {
      "width": 7,
      "height": 2,
      "x": 247,
      "y": 269,
      "translateY": -3,
      "marginLeft": 1,
      "marginRight": -1
    },
    "$": {
      "width": 6,
      "height": 12,
      "x": 115,
      "y": 263
    },
    ".": {
      "width": 2,
      "height": 2,
      "x": 121,
      "y": 273,
      "marginLeft": 1
    },
    "=": {
      "width": 8,
      "height": 4,
      "x": 123,
      "y": 268,
      "translateY": -5
    },
    "!": {
      "width": 2,
      "height": 10,
      "x": 131,
      "y": 265,
      "marginLeft": 1,
      "marginRight": 1
    },
    "<": {
      "width": 7,
      "height": 8,
      "x": 133,
      "y": 267
    },
    "#": {
      "width": 8,
      "height": 10,
      "x": 140,
      "y": 265
    },
    ">": {
      "width": 7,
      "height": 8,
      "x": 148,
      "y": 267
    },
    "(": {
      "width": 4,
      "height": 13,
      "x": 155,
      "y": 264,
      "translateY": 3
    },
    ")": {
      "width": 4,
      "height": 13,
      "x": 159,
      "y": 264,
      "translateY": 3,
      "marginLeft": 1,
      "marginRight": -1
    },
    "%": {
      "width": 10,
      "height": 10,
      "x": 163,
      "y": 265
    },
    "+": {
      "width": 8,
      "height": 8,
      "x": 173,
      "y": 266,
      "translateY": -1
    },
    "^": {
      "width": 6,
      "height": 6,
      "x": 181,
      "y": 264,
      "translateY": -5
    },
    "?": {
      "width": 5,
      "height": 10,
      "x": 187,
      "y": 265
    },
    "`": {
      "width": 3,
      "height": 3,
      "x": 192,
      "y": 265,
      "translateY": -7
    },
    "\"": {
      "width": 4,
      "height": 5,
      "x": 195,
      "y": 265,
      "translateY": -6
    },
    "'": {
      "width": 2,
      "height": 5,
      "x": 199,
      "y": 265,
      "translateY": -6
    },
    "«": {
      "width": 6,
      "height": 4,
      "x": 201,
      "y": 268,
      "translateY": -3
    },
    "»": {
      "width": 6,
      "height": 4,
      "x": 207,
      "y": 268,
      "translateY": -3
    },
    ";": {
      "width": 4,
      "height": 9,
      "x": 213,
      "y": 268,
      "translateY": 2
    },
    "/": {
      "width": 6,
      "height": 13,
      "x": 217,
      "y": 265,
      "translateY": 2
    },
    "\\": {
      "width": 6,
      "height": 13,
      "x": 264,
      "y": 265,
      "translateY": 2
    },
    "~": {
      "width": 8,
      "height": 3,
      "x": 229,
      "y": 267,
      "translateY": -5
    },
    "_": {
      "width": 8,
      "height": 2,
      "x": 237,
      "y": 273
    },
    "|": {
      "width": 2,
      "height": 13,
      "x": 245,
      "y": 264,
      "translateY": 2
    },
    "a": {
      "width": 7,
      "height": 7,
      "x": 0,
      "y": 250
    },
    "b": {
      "width": 7,
      "height": 10,
      "x": 7,
      "y": 247
    },
    "c": {
      "width": 6,
      "height": 7,
      "x": 14,
      "y": 250
    },
    "d": {
      "width": 7,
      "height": 10,
      "x": 20,
      "y": 247,
      "marginLeft": 1
    },
    "e": {
      "width": 6,
      "height": 7,
      "x": 27,
      "y": 250
    },
    "f": {
      "width": 5,
      "height": 10,
      "x": 33,
      "y": 247,
      "marginRight": -1
    },
    "g": {
      "width": 7,
      "height": 11,
      "x": 38,
      "y": 250,
      "translateY": 4
    },
    "h": {
      "width": 8,
      "height": 10,
      "x": 45,
      "y": 247
    },
    "i": {
      "width": 4,
      "height": 9,
      "x": 53,
      "y": 248
    },
    "j": {
      "width": 4,
      "height": 13,
      "x": 57,
      "y": 248,
      "translateY": 4,
      "marginLeft": -1
    },
    "k": {
      "width": 8,
      "height": 10,
      "x": 61,
      "y": 247,
      "marginRight": -1
    },
    "l": {
      "width": 4,
      "height": 10,
      "x": 69,
      "y": 247
    },
    "m": {
      "width": 12,
      "height": 7,
      "x": 73,
      "y": 250,
      "marginRight": -1
    },
    "n": {
      "width": 8,
      "height": 7,
      "x": 85,
      "y": 250
    },
    "o": {
      "width": 7,
      "height": 7,
      "x": 93,
      "y": 250
    },
    "p": {
      "width": 8,
      "height": 11,
      "x": 100,
      "y": 250,
      "translateY": 4
    },
    "q": {
      "width": 8,
      "height": 11,
      "x": 108,
      "y": 250,
      "translateY": 4,
      "marginRight": -1
    },
    "r": {
      "width": 6,
      "height": 7,
      "x": 116,
      "y": 250,
      "marginRight": -1
    },
    "s": {
      "width": 5,
      "height": 7,
      "x": 122,
      "y": 250,
      "marginRight": 1
    },
    "t": {
      "width": 5,
      "height": 9,
      "x": 127,
      "y": 248,
      "marginLeft": -1
    },
    "u": {
      "width": 8,
      "height": 7,
      "x": 132,
      "y": 250
    },
    "v": {
      "width": 8,
      "height": 7,
      "x": 140,
      "y": 250,
      "marginRight": -1
    },
    "w": {
      "width": 11,
      "height": 7,
      "x": 148,
      "y": 250
    },
    "x": {
      "width": 7,
      "height": 7,
      "x": 159,
      "y": 250
    },
    "y": {
      "width": 8,
      "height": 11,
      "x": 166,
      "y": 250,
      "translateY": 4,
      "marginRight": -1
    },
    "z": {
      "width": 7,
      "height": 7,
      "x": 174,
      "y": 250
    },
    "A": {
      "width": 10,
      "height": 10,
      "x": 181,
      "y": 247
    },
    "B": {
      "width": 8,
      "height": 10,
      "x": 191,
      "y": 247
    },
    "C": {
      "width": 9,
      "height": 10,
      "x": 199,
      "y": 247
    },
    "D": {
      "width": 10,
      "height": 10,
      "x": 208,
      "y": 247
    },
    "E": {
      "width": 8,
      "height": 10,
      "x": 218,
      "y": 247
    },
    "F": {
      "width": 7,
      "height": 10,
      "x": 226,
      "y": 247
    },
    "G": {
      "width": 10,
      "height": 10,
      "x": 233,
      "y": 247
    },
    "H": {
      "width": 11,
      "height": 10,
      "x": 243,
      "y": 247
    },
    "I": {
      "width": 4,
      "height": 10,
      "x": 254,
      "y": 247
    },
    "J": {
      "width": 5,
      "height": 13,
      "x": 258,
      "y": 247,
      "translateY": 3,
      "marginLeft": -1
    },
    "K": {
      "width": 10,
      "height": 10,
      "x": 263,
      "y": 247,
      "marginRight": -1
    },
    "L": {
      "width": 8,
      "height": 10,
      "x": 273,
      "y": 247
    },
    "M": {
      "width": 12,
      "height": 10,
      "x": 281,
      "y": 247
    },
    "N": {
      "width": 11,
      "height": 10,
      "x": 293,
      "y": 247
    },
    "O": {
      "width": 10,
      "height": 10,
      "x": 304,
      "y": 247
    },
    "P": {
      "width": 8,
      "height": 10,
      "x": 314,
      "y": 247
    },
    "Q": {
      "width": 10,
      "height": 12,
      "x": 322,
      "y": 247,
      "translateY": 2
    },
    "R": {
      "width": 9,
      "height": 10,
      "x": 332,
      "y": 247
    },
    "S": {
      "width": 7,
      "height": 10,
      "x": 341,
      "y": 247
    },
    "T": {
      "width": 8,
      "height": 10,
      "x": 348,
      "y": 247
    },
    "U": {
      "width": 10,
      "height": 10,
      "x": 356,
      "y": 247
    },
    "V": {
      "width": 10,
      "height": 10,
      "x": 366,
      "y": 247,
      "marginRight": -1
    },
    "W": {
      "width": 14,
      "height": 10,
      "x": 376,
      "y": 247,
      "marginRight": -1
    },
    "X": {
      "width": 9,
      "height": 10,
      "x": 390,
      "y": 247
    },
    "Y": {
      "width": 9,
      "height": 10,
      "x": 399,
      "y": 247
    },
    "Z": {
      "width": 9,
      "height": 10,
      "x": 408,
      "y": 247
    },
    "а": {
      "sameAs": "a"
    },
    "б": {
      "width": 6,
      "height": 10,
      "x": 0,
      "y": 283,
      "marginLeft": 1
    },
    "в": {
      "width": 6,
      "height": 7,
      "x": 6,
      "y": 286
    },
    "г": {
      "width": 7,
      "height": 7,
      "x": 12,
      "y": 286,
      "marginRight": -1
    },
    "д": {
      "width": 8,
      "height": 9,
      "x": 19,
      "y": 286,
      "translateY": 2,
      "marginRight": -1
    },
    "е": {
      "sameAs": "e"
    },
    "ё": {
      "width": 6,
      "height": 9,
      "x": 27,
      "y": 284
    },
    "ж": {
      "width": 10,
      "height": 7,
      "x": 33,
      "y": 286
    },
    "з": {
      "width": 5,
      "height": 7,
      "x": 43,
      "y": 286
    },
    "и": {
      "width": 8,
      "height": 7,
      "x": 48,
      "y": 286
    },
    "й": {
      "width": 8,
      "height": 9,
      "x": 56,
      "y": 284
    },
    "к": {
      "width": 8,
      "height": 7,
      "x": 64,
      "y": 286,
      "marginRight": -1
    },
    "л": {
      "width": 7,
      "height": 7,
      "x": 72,
      "y": 286
    },
    "м": {
      "width": 10,
      "height": 7,
      "x": 79,
      "y": 286,
      "marginRight": -1
    },
    "н": {
      "width": 8,
      "height": 7,
      "x": 89,
      "y": 286
    },
    "о": {
      "sameAs": "o"
    },
    "п": {
      "width": 8,
      "height": 7,
      "x": 97,
      "y": 286
    },
    "р": {
      "sameAs": "p"
    },
    "с": {
      "sameAs": "c"
    },
    "т": {
      "width": 6,
      "height": 7,
      "x": 105,
      "y": 286
    },
    "у": {
      "sameAs": "y"
    },
    "ф": {
      "width": 11,
      "height": 14,
      "x": 121,
      "y": 283,
      "translateY": 4
    },
    "х": {
      "sameAs": "x"
    },
    "ц": {
      "width": 8,
      "height": 9,
      "x": 132,
      "y": 286,
      "translateY": 2
    },
    "ч": {
      "width": 8,
      "height": 7,
      "x": 140,
      "y": 286,
      "marginRight": -1
    },
    "ш": {
      "width": 12,
      "height": 7,
      "x": 148,
      "y": 286,
      "marginRight": -1
    },
    "щ": {
      "width": 12,
      "height": 9,
      "x": 160,
      "y": 286,
      "translateY": 2,
      "marginLeft": -1
    },
    "ъ": {
      "width": 7,
      "height": 7,
      "x": 172,
      "y": 286
    },
    "ы": {
      "width": 11,
      "height": 7,
      "x": 179,
      "y": 286,
      "marginRight": -1
    },
    "ь": {
      "width": 6,
      "height": 7,
      "x": 190,
      "y": 286
    },
    "э": {
      "width": 6,
      "height": 7,
      "x": 196,
      "y": 286
    },
    "ю": {
      "width": 10,
      "height": 7,
      "x": 202,
      "y": 286
    },
    "я": {
      "width": 8,
      "height": 7,
      "x": 212,
      "y": 286,
      "marginRight": -1
    },
    "А": {
      "sameAs": "A"
    },
    "Б": {
      "width": 8,
      "height": 10,
      "x": 220,
      "y": 283
    },
    "В": {
      "sameAs": "B"
    },
    "Г": {
      "width": 8,
      "height": 10,
      "x": 228,
      "y": 283,
      "marginRight": -1
    },
    "Д": {
      "width": 10,
      "height": 12,
      "x": 236,
      "y": 283,
      "translateY": 2
    },
    "Е": {
      "sameAs": "E"
    },
    "Ё": {
      "width": 8,
      "height": 12,
      "x": 246,
      "y": 281
    },
    "Ж": {
      "width": 14,
      "height": 10,
      "x": 254,
      "y": 283,
      "marginRight": -1
    },
    "З": {
      "width": 7,
      "height": 10,
      "x": 268,
      "y": 283
    },
    "И": {
      "width": 11,
      "height": 10,
      "x": 275,
      "y": 283
    },
    "Й": {
      "width": 11,
      "height": 12,
      "x": 286,
      "y": 281
    },
    "К": {
      "sameAs": "K"
    },
    "Л": {
      "width": 10,
      "height": 10,
      "x": 297,
      "y": 283
    },
    "М": {
      "sameAs": "M"
    },
    "Н": {
      "sameAs": "H"
    },
    "О": {
      "sameAs": "O"
    },
    "П": {
      "width": 11,
      "height": 10,
      "x": 307,
      "y": 283
    },
    "Р": {
      "sameAs": "P"
    },
    "С": {
      "sameAs": "C"
    },
    "Т": {
      "sameAs": "T"
    },
    "У": {
      "width": 10,
      "height": 13,
      "x": 318,
      "y": 283,
      "translateY": 3,
      "marginRight": -1
    },
    "Ф": {
      "width": 12,
      "height": 10,
      "x": 328,
      "y": 283,
      "marginRight": -1
    },
    "Х": {
      "sameAs": "X"
    },
    "Ц": {
      "width": 12,
      "height": 12,
      "x": 340,
      "y": 283,
      "translateY": 2,
      "marginRight": -1
    },
    "Ч": {
      "width": 10,
      "height": 10,
      "x": 352,
      "y": 283
    },
    "Ш": {
      "width": 14,
      "height": 10,
      "x": 362,
      "y": 283
    },
    "Щ": {
      "width": 15,
      "height": 12,
      "x": 376,
      "y": 283,
      "translateY": 2,
      "marginRight": -1
    },
    "Ъ": {
      "width": 9,
      "height": 10,
      "x": 391,
      "y": 283
    },
    "Ы": {
      "width": 11,
      "height": 10,
      "x": 400,
      "y": 283,
      "marginRight": 1
    },
    "Ь": {
      "width": 8,
      "height": 10,
      "x": 411,
      "y": 283,
      "marginLeft": 1
    },
    "Э": {
      "width": 9,
      "height": 10,
      "x": 419,
      "y": 283
    },
    "Ю": {
      "width": 15,
      "height": 10,
      "x": 428,
      "y": 283
    },
    "Я": {
      "width": 9,
      "height": 10,
      "x": 443,
      "y": 283
    },
    "{": {
      "width": 3,
      "height": 11,
      "x": 262,
      "y": 264
    },
    "}": {
      "width": 3,
      "height": 11,
      "x": 265,
      "y": 264
    },
    "Ђ": {
      "width": 10,
      "height": 11,
      "x": 0,
      "y": 304,
      "translateY": 1
    },
    "Ѓ": {
      "width": 8,
      "height": 13,
      "x": 10,
      "y": 301
    },
    "‚": {
      "width": 3,
      "height": 4,
      "x": 29,
      "y": 311,
      "translateY": 1
    },
    "ѓ": {
      "width": 7,
      "height": 10,
      "x": 22,
      "y": 304
    },
    "„": {
      "width": 6,
      "height": 4,
      "x": 29,
      "y": 311,
      "translateY": 1
    },
    "…": {
      "width": 10,
      "height": 2,
      "x": 35,
      "y": 312
    },
    "†": {
      "width": 6,
      "height": 12,
      "x": 45,
      "y": 304,
      "translateY": 2
    },
    "‡": {
      "width": 6,
      "height": 12,
      "x": 51,
      "y": 304,
      "translateY": 2
    },
    "€": {
      "width": 8,
      "height": 10,
      "x": 57,
      "y": 304
    },
    "‰": {
      "width": 15,
      "height": 10,
      "x": 65,
      "y": 304
    },
    "Љ": {
      "width": 13,
      "height": 10,
      "x": 80,
      "y": 304
    },
    "‹": {
      "width": 3,
      "height": 4,
      "x": 297,
      "y": 309
    },
    "Њ": {
      "width": 14,
      "height": 10,
      "x": 96,
      "y": 304
    },
    "Ќ": {
      "width": 10,
      "height": 13,
      "x": 110,
      "y": 301
    },
    "Ћ": {
      "width": 10,
      "height": 10,
      "x": 120,
      "y": 304
    },
    "Џ": {
      "width": 10,
      "height": 12,
      "x": 130,
      "y": 304,
      "translateY": 2
    },
    "ђ": {
      "width": 7,
      "height": 11,
      "x": 140,
      "y": 304,
      "translateY": 1
    },
    "‘": {
      "width": 3,
      "height": 4,
      "x": 29,
      "y": 311,
      "translateY": -6
    },
    "’": {
      "sameAs": "‘"
    },
    "“": {
      "width": 6,
      "height": 4,
      "x": 29,
      "y": 311,
      "translateY": -6
    },
    "”": {
      "sameAs": "“"
    },
    "•": {
      "width": 5,
      "height": 5,
      "x": 147,
      "y": 306,
      "translateY": -3
    },
    "—": {
      "width": 10,
      "height": 2,
      "x": 159,
      "y": 306,
      "translateY": -3
    },
    "˜": {
      "width": 8,
      "height": 9,
      "x": 169,
      "y": 305
    },
    "™": {
      "width": 13,
      "height": 6,
      "x": 177,
      "y": 304,
      "translateY": -4
    },
    "љ": {
      "width": 10,
      "height": 7,
      "x": 190,
      "y": 307
    },
    "›": {
      "width": 3,
      "height": 4,
      "x": 381,
      "y": 308,
      "translateY": -1
    },
    "њ": {
      "width": 11,
      "height": 7,
      "x": 203,
      "y": 307
    },
    "ќ": {
      "width": 8,
      "height": 10,
      "x": 214,
      "y": 304
    },
    "ћ": {
      "width": 8,
      "height": 10,
      "x": 222,
      "y": 304
    },
    "џ": {
      "width": 8,
      "height": 9,
      "x": 230,
      "y": 307,
      "translateY": 2
    },
    "Ӯ": {
      "width": 10,
      "height": 15,
      "x": 238,
      "y": 302,
      "translateY": 3
    },
    "ӯ": {
      "width": 7,
      "height": 13,
      "x": 248,
      "y": 305,
      "translateY": 4
    },
    "Ј": {
      "sameAs": "J"
    },
    "¤": {
      "width": 8,
      "height": 8,
      "x": 256,
      "y": 305,
      "translateY": -1
    },
    "Ґ": {
      "width": 6,
      "height": 11,
      "x": 264,
      "y": 303
    },
    "¦": {
      "sameAs": "|"
    },
    "§": {
      "width": 7,
      "height": 12,
      "x": 270,
      "y": 304,
      "translateY": 2
    },
    "©": {
      "width": 11,
      "height": 10,
      "x": 277,
      "y": 304
    },
    "Є": {
      "width": 9,
      "height": 10,
      "x": 288,
      "y": 304
    },
    "¬": {
      "width": 8,
      "height": 4,
      "x": 303,
      "y": 307,
      "translateY": -3
    },
    "®": {
      "width": 11,
      "height": 10,
      "x": 311,
      "y": 304
    },
    "Ї": {
      "width": 5,
      "height": 12,
      "x": 322,
      "y": 302
    },
    "°": {
      "width": 5,
      "height": 5,
      "x": 327,
      "y": 303,
      "translateY": -5
    },
    "±": {
      "width": 8,
      "height": 10,
      "x": 332,
      "y": 303
    },
    "І": {
      "sameAs": "I"
    },
    "і": {
      "sameAs": "i"
    },
    "ґ": {
      "width": 5,
      "height": 8,
      "x": 340,
      "y": 305
    },
    "µ": {
      "width": 6,
      "height": 9,
      "x": 345,
      "y": 306,
      "translateY": 2
    },
    "¶": {
      "width": 7,
      "height": 13,
      "x": 351,
      "y": 303,
      "translateY": 3
    },
    "·": {
      "width": 2,
      "height": 2,
      "x": 358,
      "y": 309,
      "translateY": -2
    },
    "№": {
      "width": 15,
      "height": 10,
      "x": 360,
      "y": 303
    },
    "є": {
      "width": 6,
      "height": 7,
      "x": 375,
      "y": 306
    },
    "ј": {
      "sameAs": "j"
    },
    "Ѕ": {
      "sameAs": "S"
    },
    "ѕ": {
      "sameAs": "s"
    },
    "ї": {
      "width": 5,
      "height": 9,
      "x": 387,
      "y": 304
    },
    "ą": {
      "width": 8,
      "height": 10,
      "x": 0,
      "y": 322,
      "translateY": 3
    },
    "ć": {
      "width": 6,
      "height": 10,
      "x": 8,
      "y": 319
    },
    "ę": {
      "width": 6,
      "height": 10,
      "x": 14,
      "y": 322,
      "translateY": 3
    },
    "ł": {
      "width": 6,
      "height": 10,
      "x": 20,
      "y": 319
    },
    "ń": {
      "width": 8,
      "height": 10,
      "x": 26,
      "y": 319
    },
    "ó": {
      "width": 7,
      "height": 10,
      "x": 34,
      "y": 319
    },
    "ś": {
      "width": 5,
      "height": 10,
      "x": 41,
      "y": 319
    },
    "ź": {
      "width": 7,
      "height": 10,
      "x": 46,
      "y": 319
    },
    "ż": {
      "width": 7,
      "height": 10,
      "x": 53,
      "y": 319
    },
    "Ą": {
      "width": 10,
      "height": 14,
      "x": 60,
      "y": 319,
      "translateY": 4
    },
    "Ć": {
      "width": 9,
      "height": 13,
      "x": 70,
      "y": 316
    },
    "Ę": {
      "width": 9,
      "height": 14,
      "x": 79,
      "y": 319,
      "translateY": 4
    },
    "Ł": {
      "width": 10,
      "height": 10,
      "x": 88,
      "y": 319
    },
    "Ń": {
      "width": 11,
      "height": 13,
      "x": 98,
      "y": 316
    },
    "Ó": {
      "width": 10,
      "height": 13,
      "x": 109,
      "y": 316
    },
    "Ś": {
      "width": 7,
      "height": 13,
      "x": 119,
      "y": 316
    },
    "Ź": {
      "width": 9,
      "height": 13,
      "x": 126,
      "y": 316
    },
    "Ż": {
      "width": 9,
      "height": 13,
      "x": 135,
      "y": 316
    },
    "á": {
      "width": 7,
      "height": 10,
      "x": 144,
      "y": 319
    },
    "é": {
      "width": 6,
      "height": 10,
      "x": 151,
      "y": 319
    },
    "í": {
      "width": 4,
      "height": 10,
      "x": 157,
      "y": 319
    },
    "ö": {
      "width": 7,
      "height": 9,
      "x": 161,
      "y": 320
    },
    "ő": {
      "width": 7,
      "height": 10,
      "x": 168,
      "y": 319
    },
    "ü": {
      "width": 8,
      "height": 9,
      "x": 175,
      "y": 320
    },
    "ú": {
      "width": 8,
      "height": 10,
      "x": 183,
      "y": 319
    },
    "ű": {
      "width": 8,
      "height": 10,
      "x": 191,
      "y": 319
    },
    "Á": {
      "width": 10,
      "height": 13,
      "x": 199,
      "y": 316
    },
    "É": {
      "width": 8,
      "height": 13,
      "x": 209,
      "y": 316
    },
    "Í": {
      "width": 4,
      "height": 13,
      "x": 217,
      "y": 316
    },
    "Ö": {
      "width": 10,
      "height": 12,
      "x": 221,
      "y": 317
    },
    "Ő": {
      "width": 10,
      "height": 13,
      "x": 231,
      "y": 316
    },
    "Ü": {
      "width": 10,
      "height": 12,
      "x": 241,
      "y": 317
    },
    "Ú": {
      "width": 10,
      "height": 13,
      "x": 251,
      "y": 316
    },
    "Ű": {
      "width": 10,
      "height": 13,
      "x": 261,
      "y": 316
    }
  }